import { Badge, Button, Table } from '@mantine/core';
import { useRunZmSync, useZmSyncLog, useZmSyncStatus } from '../hooks/useZmSync';
import { colors } from '../theme/colors';
import { zmWhen } from './ZmSyncBanner';

const statusLabel: Record<string, { label: string; color: string }> = {
  running: { label: 'läuft', color: 'yellow' },
  success: { label: 'erfolgreich', color: 'green' },
  skipped: { label: 'übersprungen', color: 'orange' },
  failed: { label: 'fehlgeschlagen', color: 'red' },
};

const StatusBadge = ({ status }: { status: string }) => {
  const s = statusLabel[status] ?? { label: status, color: 'gray' };
  return <Badge color={s.color}>{s.label}</Badge>;
};

const sectionTitle = { margin: '1.5rem 0 0.5rem', fontSize: '1.1rem', color: colors.primary.background } as const;

export function ZmSyncAdmin() {
  const { data: status } = useZmSyncStatus();
  const { run, running } = useRunZmSync();
  const busy = running || !!status?.running;
  const { data: runs = [] } = useZmSyncLog(busy);

  const trigger = async () => {
    if (
      !window.confirm(
        'ZM-Synchronisierung jetzt starten?\n\nZM-Urlaub/-Abwesenheit überschreibt vorhandene Einträge an diesen Tagen.'
      )
    )
      return;
    const result = await run();
    if (result) {
      alert(
        `ZM-Synchronisierung ${statusLabel[result.status]?.label ?? result.status}: ` +
          `${result.rows_created ?? 0} Tage erstellt, ${result.rows_deleted ?? 0} alte Zeilen entfernt.`
      );
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
        <div>
          Status: {busy ? <StatusBadge status="running" /> : status?.last ? <StatusBadge status={status.last.status} /> : '–'}
        </div>
        <div>Letzter erfolgreicher Sync: {zmWhen(status?.last_success_at)}</div>
        <div style={{ color: colors.neutral.grey[600] }}>Automatisch: Mo–Fr 08:00 und 14:00 Uhr</div>
        <Button onClick={trigger} loading={running} disabled={busy} style={{ marginLeft: 'auto' }}>
          Jetzt synchronisieren
        </Button>
      </div>

      <h3 style={sectionTitle}>Letzte Läufe</h3>
      <Table striped withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Start</Table.Th>
            <Table.Th>Ende</Table.Th>
            <Table.Th>Status</Table.Th>
            <Table.Th>Erstellt</Table.Th>
            <Table.Th>Entfernt</Table.Th>
            <Table.Th>Hinweis</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {runs.map((r) => (
            <Table.Tr key={r.id}>
              <Table.Td>{zmWhen(r.started_at)}</Table.Td>
              <Table.Td>{zmWhen(r.finished_at)}</Table.Td>
              <Table.Td>
                <StatusBadge status={r.status} />
              </Table.Td>
              <Table.Td>{r.rows_created ?? 0}</Table.Td>
              <Table.Td>{r.rows_deleted ?? 0}</Table.Td>
              <Table.Td>
                {r.reason === 'zm_empty' ? 'Die ZM-Tabelle scheint leer zu sein.' : (r.message ?? '')}
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
}
